import { Alert, AlertColor } from "@mui/material";
import { forwardRef } from "react";

type Props = {
  message: string;
  type?: AlertColor;
};

const CustomeSnackbar = forwardRef<HTMLDivElement, Props>(
  ({ message, type = "success" }, ref) => {
    return (
      <Alert
        ref={ref}
        severity={type}
        sx={{
          maxWidth: "400px",
          boxShadow: 4,
        }}
      >
        {message}
      </Alert>
    );
  }
);

export default CustomeSnackbar